<template>
    <div class="page noScroll">
        <div class="page-content infinite-scroll noScroll" style="overflow: hidden;">
            <!-- nav -->
            <div class="review-nav bg-white">
                <router-link tag="div" class="review-nav-item div--inlineBlock active" to="/Rccl.Review/ReviewPicture/OwnPicture"><span>我的美图</span></router-link>
                <div class="line div--inlineBlock"></div>
                <router-link tag="div" class="review-nav-item div--inlineBlock" to="/Rccl.Review/Travel/OwnReview"><span>我的游记</span></router-link>
            </div>
            <!--查看所有美图-->
            <div class="review-seeAll"><router-link to="/Rccl.Review/ReviewPicture/Index" class="external">查看所有美图</router-link></div>
            <!-- list-container -->
            <div class="list-container infinite-scroll bg-white noScroll">
                <div class="review-list bg-white scroll-container">
                    <div class="review-listContainer" v-for="(item, index) in picsList" :key="index" v-bind:class="{hide: picsList.length === 0}">
                        <div class="review-list-tips border-grey">
                            <span>{{item.year}}</span>
                        </div>
                        <div class="review-list-content bg-white">
                            <router-link tag="div" class="review-list-item external" v-for="_item in item.list" :key="_item.id" :to="`/Rccl.Review/ReviewPicture/Detail?reviewPicId=${_item.id}`" v-bind:class="{hide: _item.status === 25}">
                                <div>
                                    <div class="review-item-imgInfo">
                                        <div class="review-item-img">
                                            <img :src="_item.titleImage" title="美图封面图">
                                        </div>
                                        <div class="review-item-imgName">{{_item.content}}</div>
                                    </div>
                                    <div class="review-item-status">{{getStatus(_item.status)}}</div>
                                </div>
                                <p class="review-list-dateMD">{{_item.createdTime}}</p>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div v-if="picsList.length === 0">
                    <div class="review-list-nodata  scroll-container">暂无数据，请先上传美照</div>
                    <div class="button_content scroll-container">
                        <p><router-link to="/Rccl.Review/ReviewPicture/Index" class="external">查看所有美图</router-link></p>
                    </div>
                </div>
            </div>

            <!-- upload pic -->
            <UploadPic></UploadPic>
        </div>
    </div>
</template>

<script>
    import api from '@/api'
    import UploadPic from '@/components/Review/UploadPic.vue'
    export default {
        name: 'ContactCreate',
        components: {
            UploadPic
        },
        data () {
            return {
                userToken: '',
                picsList: []
            }
        },
        beforeMount () {
            this.$store.commit('SET_PAGE_TITLE', '秀美图')
            this.showPage()
        },
        methods: {
            async showPage () {
                this.$loading.show()
                await this.initPage()
                this.$loading.hide()
            },
            async initPage () {
                const userToken = this.$store.state.user.userToken
                if (!userToken || userToken.length == 0) {
					this.$router.push(`/Orchard.Rccl.Users/Login/Login?returnUrl=${encodeURIComponent(window.location.pathname)}`)
                    return
                }

				this.userToken = userToken
				this.$store.commit('SET_REWARD_TOKEN', this.userToken)

                // 获取美图列表
                this.picsList = await this.getMinePics()

                // 根据年份分组
                this.picsList = this.chunk(this.picsList)
            },
            async getMinePics () {
                const {success, data, errMsg} = await api.review.getMinePic({
                    Offset: 0,
                    Limit: 1000
                })
                if (!success) {
                    console.log(errMsg)
                    return null
                } else {
                    return data
                }
            },
            chunk (array)  {
                let result = []
                if (array.length === 0) return result
                array.map(item => {
                    let itemYear = item.createdDate.split('-')[0]
                    if (result.length === 0) {
                        result.push({
                            year: itemYear,
                            list: [item]
                        })
                    } else {
                        let res = result.some((resultItem, index) => {
                            if (resultItem.year === itemYear) {
                                result[index].list.push(item)
                                return true
                            }
                        })
                        if (!res) {
                            result.push({
                                year: itemYear,
                                list: [item]
                            })
                        }
                    }
                })
                return result
            },
            getStatus (status) {
                switch (status) {
                    case 0:
                        return '草稿'
                    case 5:
                        return '审核中...'
                    case 15:
                        return '审核通过'
                    case 20:
                        return '审核未通过'
                    case 25:
                        return '已删除'
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .page {
        display: block;
        background: #F6F7F8 !important;
    }
    .page-content{
        padding-top: 50px;
    }

    /****===== nav =====****/
    .review-nav {
        height: 44px;
        line-height: 44px;
        font-size: 13px;
        color: #777;
        border-bottom: 1px solid #e0e0e0;
    }
    .review-nav .review-nav-item {
        width: 48.7%;
        text-align: center;
    }
    .review-nav .line {
        width: 1px;
        height: 32px;
        background: #ddd;
    }
    .review-nav .active span{
        color: #061556;
        border-bottom: 2px solid #f9b811;
        padding-bottom: 6px;
    }

    /**** 查看所有美图 ****/
    .list-container{
        min-height: calc(100vh - 50px - 44px - 36px);
    }
    .review-seeAll {
        background-color:#fff;
        text-align:center;
        a{
            display:inline-block;
            width: 100%;
            height: 36px;
            line-height: 36px;
            text-align: center;
            background-color: #f7b611;
            font-size: 12.5px;
            color: #fff;
            border: none;
        }
    }

    /****===== list =====****/
    .review-list {
        overflow-y: auto;
        padding-bottom:30px;
    }
    .review-list-nodata {
        font-size:13px;
        text-align:center;
        margin-top:20px;
        font-weight:bold;
    }
    .review-listContainer {
        /*border-top: 1px solid #e0e0e0;*/
        padding: 0 12px;
        &.hide{
            display: none;
        }
    }
    .review-listContainer>div:last-child{
        border:none;
    }
    .review-list-tips {
        height: 42px;
        line-height:42px;
        font-size: 12px;
        text-align:center;
        display:flex;
        flex-direction:column;
        -webkit-flex-direction:column;
        justify-content:center;
    }
    .review-list-tips >span{
        font-size:13px;
        margin:0;
        font-weight:bold;
        color:#000;
        vertical-align:middle;
    }
    .review-list-tips >span:before{
        content:"";
        width:40%;
        height:1px;
        background-color:#f1c047;
        vertical-align:middle;
        display:inline-block;
        margin-right:5%;
    }
    .review-list-tips >span:after{
        content:"";
        width:40%;
        height:1px;
        background-color:#f1c047;
        vertical-align:middle;
        display:inline-block;
        margin-left:5%;
    }
    .review-list-content {
        margin-top:12px;
        overflow: hidden;
        border-bottom:1px solid #e0e0e0;
    }
    .review-list-item {
        float: left;
        width: 172px;
        margin-bottom: 14px;
        position: relative;
        overflow: hidden;
        padding: 6px;
        border: 1px solid #f5f4f4;
        &.hide{
            display: none;
        }
    }
    .review-list-item:nth-child(2n+1) {
        margin-right:6px;
    }
    .review-list-item>div {
        position:relative;
    }
    .review-item-imgInfo {
        width:100%;
        position:relative;
    }
    .review-item-imgInfo .review-item-img {
        width:100%;
        height:117px;
        overflow:hidden;
    }
    .review-item-imgInfo .review-item-img img{
        position:relative;
        left:50%;
        top:50%;
        transform:translate(-50%,-50%);
        -webkit-transform:translate(-50%,-50%);
        -moz-transform:translate(-50%,-50%);
        -o-transform:translate(-50%,-50%);
        -ms-transform:translate(-50%,-50%);
        max-width:100%;
        max-height:100%;
    }
    .review-item-imgInfo .review-item-imgName {
        width:100%;
        height:30px;
        line-height:30px;
        background-color:rgba(0,0,0,.5);
        color:#fff;
        font-size:12px;
        padding-left:10px;
        position:absolute;
        bottom:0;
        left:0;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
    }
    .review-list-dateMD {
        margin: 4px 0 0 0;
        color: #454545;
        font-size: 12px;
        clear:both;
        text-align:center;
    }
    .review-item-status {
        position:absolute;
        top:0;
        left:0;
        background-color:rgba(0,0,0,.4);
        width:100%;
        height:100%;
        display:flex;
        flex-direction:row;
        -webkit-flex-direction:row;
        justify-content:center;
        -webkit-justify-content:center;
        align-items:center;
        -webkit-align-items:center;
        color:#fff;
        font-size:15px;
        font-weight:bold;
    }

    .review-list-nodata {
        font-size: 14px;
        color: #091552;
    }
    .review-list-nodata img{
        width: 10%;
    }

    .button_content {
        text-align: center;
    }

    .button_content a {
        padding: 6px 25px;
        background-color: #f7b611;
        color: #fff;
        font-size: 14px;
        border-radius: 20px;
    }
</style>
